import styled from 'styled-components';

export const SectionHeading = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SectionSub = styled.p`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
  margin-bottom: 3.2rem;
  line-height: 1.5;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;
